var _path, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3.75V11.5C1.75 12.6046 2.64543 13.5 3.75 13.5H8.7566V18.3L12.2757 13.5H16.25C17.3546 13.5 18.25 12.6046 18.25 11.5V3.75C18.25 2.64543 17.3546 1.75 16.25 1.75H3.75C2.64543 1.75 1.75 2.64543 1.75 3.75Z",
    stroke: "#FF5F14",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 5.80819,
    cy: 7.80819,
    r: 0.80819,
    fill: "#FF5F14"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.98495,
    cy: 7.80819,
    r: 0.80819,
    fill: "#FF5F14"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.1617,
    cy: 7.80819,
    r: 0.80819,
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatIconOrange);
export default __webpack_public_path__ + "static/media/chat_icon_orange.f1fca68d4f3dc103818bca1d1f56b61b.svg";
export { ForwardRef as ReactComponent };